import { portalBase2v } from '@App/dicts/pathes'

export class Notification {
    token = () => portalBase2v('notification/token')
}
